import React from "react";

import "./index.scss";

const AnalyticsIcon = props => (
  <svg id="Basline_SVG" data-name="Reports" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="analytics-icon">
    <rect id="Rectangle_178" data-name="Rectangle 178" className="cls-1" width="79" height="68" />
    <g id="Analytics_Small" data-name="Analytics Small" transform="translate(16 16)" className={`default ${props.active ? "active" : ""}`}>
      <g id="Group_17424" data-name="Group 17424" transform="translate(-16 -16)">
        <path id="margin" className="cls-3" d="M0,0H32V32H0Z" />
        <path
          id="Rectangle_342"
          data-name="Rectangle 342"
          className="cls-4"
          d="M5.937,4.281H26.062A1.452,1.452,0,0,1,27.5,5.746V26.254a1.452,1.452,0,0,1-1.438,1.465H5.937A1.452,1.452,0,0,1,4.5,26.254V5.746A1.452,1.452,0,0,1,5.937,4.281Z"
          transform="translate(0 0)"
        />
        <path
          id="Path_15851"
          data-name="Path 15851"
          className="cls-5"
          d="M22.154,11.385a1.848,1.848,0,0,0-1.846,1.846,1.824,1.824,0,0,0,.238.889l-2.108,2.845a1.781,1.781,0,0,0-1.216.164l-1.462-1.1a1.825,1.825,0,0,0,.034-.341,1.846,1.846,0,0,0-3.692,0,1.825,1.825,0,0,0,.035.341l-1.462,1.1a1.823,1.823,0,0,0-.829-.206,1.853,1.853,0,1,0,1.687,1.1l1.234-.926a1.809,1.809,0,0,0,2.363,0l1.235.926a1.848,1.848,0,1,0,3.12-.4l1.983-2.678a1.845,1.845,0,1,0,.686-3.557Zm-12.308,8a.616.616,0,1,1,.616-.616A.617.617,0,0,1,9.846,19.385Zm4.1-3.077a.616.616,0,1,1,.616-.616A.616.616,0,0,1,13.948,16.308Zm4.1,3.077a.616.616,0,1,1,.615-.616A.618.618,0,0,1,18.052,19.385Zm4.1-5.539a.616.616,0,1,1,.615-.615A.617.617,0,0,1,22.154,13.846Z"
          transform="translate(0 0)"
        />
      </g>
    </g>
  </svg>
);

export default AnalyticsIcon;
